import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { AutocompleteOnSelect } from 'types'

export const EmailInviteDropdownItem = ({
  query,
  onSelect,
}: {
  query: string

  onSelect: AutocompleteOnSelect
}) => (
  <Dropdown.Item onSelect={onSelect({ id: 0, value: query, payload: query })}>
    Invite the email {query} to use this application
  </Dropdown.Item>
)
